export type StarsRatingBarProps = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook?: string;

  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;

  /** Controls the size of the star rating bar. Interactive mode can be `large` or `medium`. The default value for the read only mode is `medium`. */
  size?: 'tiny' | 'small' | 'medium' | 'large';

  /** Specifies whether the rating bar is in read-only mode. */
  readOnly?: boolean;

  /** Specifies the rate input value labels. */
  labelValues?: Array<string>;

  /** Specifies the rate caption value labels. Array must contain all 5 strings to display the rating labels. */
  descriptionValues?: Array<string>;

  /** Specifies the selected rate. 0 indicates an undefined rating. */
  value: 0 | 1 | 2 | 3 | 4 | 5;

  /** Defines a handler that is called whenever rating changes.
   * ##### Signature:
   * function(rating: number) => void
   * * * `rating`: 1 | 2 | 3 | 4 | 5
   * */
  onChange?: (rating: number) => void;

  /** Specifies radio group name. */
  name?: string;
};
